module.exports = __webpack_public_path__ + "img/micro.722d4767.png";